// Import constant variables
const { VIMEO_OEMBED_URL, ERROR_MESSAGES } = require('./constants');

const fetchVimeoData = async ( url ) => {
    try {
        const resp = await fetch(`${VIMEO_OEMBED_URL}${url}&responsive=1`)
        if (resp.ok) {  
            return await resp.json();
        } else {
            if (resp.status === 401) {
                throw new Error(ERROR_MESSAGES.UNAUTHORIZED_ACCESS);
            } else if (resp.status === 404) {
                throw new Error(ERROR_MESSAGES.NOT_FOUND);
            } else {
                throw new Error(`Error fetching video from Vimeo: ${resp.statusText}`);
            }

        }
    } catch(err) {
        throw err;
    }
}

module.exports = { fetchVimeoData };